export default "__VITE_ASSET__B9uK7i9n__"